import React, { useContext } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import { AuthenticatedContext, ModuleContext } from "../App";
import { useHistory, useLocation } from "react-router-dom";
import parse from "html-react-parser";
import { Box } from "@mui/system";
import { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import AppsIcon from "@mui/icons-material/Apps";
import FlagIcon from "@mui/icons-material/Flag";

const Instructions = () => {
  const { moduleSettings, createSitting, exitSitting } = useContext(ModuleContext);
  const history = useHistory();
  const location = useLocation();
  const [instructionStep, setInstructionStep] = useState(2);
  const { loading, setLoading } = useContext(AuthenticatedContext);

  async function startTest() {
    setLoading(true);
    await createSitting();

    if (
      moduleSettings.moduleType === "Placement" ||
      moduleSettings.moduleType === "Diagnostic"
    ) {
      history.push("/placement-question");
    } else if (moduleSettings.moduleType === "Training" || moduleSettings.moduleType === "Interactive") {
      history.push("/training-question");
    }
  }

  function goToDashboard() {
    exitSitting();
    if(location.from === "/studenttraining" || location.from === "/training-question") {
      return history.push("/studenttraining")
    }
    history.push("/assessments");
  }

  const handlePrevStep = () => {
    setInstructionStep(prev => prev - 1)
  }

  const handleNextStep = () => {
    setInstructionStep(prev => prev + 1)
  }

  if (moduleSettings?.selectedModule.languageId === 1) {
    return (
      <Grid container spacing={2}>
        { moduleSettings.moduleType === "Placement" && (
          <>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Typography variant="h4">
                {moduleSettings.selectedModule.name}
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              {moduleSettings.moduleType === "Placement" && (
                <Typography variant="subtitle1">
                  Duration: {moduleSettings.selectedModule.duration} minutes
                </Typography>
              )}
              <Typography variant="subtitle1">
                Total Questions: {moduleSettings.selectedModule.totalQuestions}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Instructions for SolverEdge Problem Solving Assessment
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                Please read the Instructions carefully before starting the test.
              </Typography>
              <ol>
                <li>
                  <Typography variant="body1">
                    After you have selected an answer, click Next button to proceed to the following question.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    Questions may be attempted in any order, and you may skip up to 4 questions at a time. Click Next to skip the question.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    You can change the answer anytime within the allocated test time.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    The colour-coded boxes labelled with each test question number, located on the review page, indicates the status of each test question. Please see the key below:
                  </Typography>
                  <br />
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={2}
                      sx={{
                        ml: 1,
                        color: "black",
                        backgroundColor: "#9e9e9e",
                        textAlign: "center",
                      }}
                    >
                      Grey
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="body1">
                        Not answered / Skipped question
                      </Typography>
                    </Grid>
                    <Grid item xs={1} />
                    <Grid
                      item
                      xs={2}
                      sx={{
                        ml: 1,
                        color: "black",
                        backgroundColor: "#fdd835",
                        textAlign: "center",
                      }}
                    >
                      Yellow
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="body1">Answered question</Typography>
                    </Grid>
                  </Grid>
                  <br />
                </li>
                <li>
                  <Typography variant="body1">
                    To skip and/or flag the question to return to, press the <FlagIcon sx={{ color: "#C10015" }} />
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    To review your answers, press <AppsIcon sx={{ color: "#C10015"}} />
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    Do not submit unless you have reviewed all the answers. You will not be permitted to change your answer once you submit your test.
                  </Typography>
                </li>
              </ol>
            </Grid>
            <Grid item xs={12}>
              <Box display={"flex"} justifyContent="center">
                <Button
                  variant="contained"
                  onClick={goToDashboard}
                  sx={{ mr: 4 }}
                  disabled={loading}
                >
                  Return to Dashboard
                </Button>
                <Button
                  variant="contained"
                  onClick={startTest}
                  disabled={loading}
                >
                  Start Test
                </Button>
              </Box>
            </Grid>
          </>
        )}
        {(
          moduleSettings.moduleType === "Training" || moduleSettings.moduleType === "Interactive") && (
          <>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Typography variant="h4">
                {moduleSettings.selectedModule.name}
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              {moduleSettings.moduleType === "Placement" && (
                <Typography variant="subtitle1">
                  Duration: {moduleSettings.selectedModule.duration} minutes
                </Typography>
              )}
              <Typography variant="subtitle1">
                Total Questions: {moduleSettings.selectedModule.totalQuestions}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {moduleSettings.moduleType !== "Training" && 
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Instructions for SolverEdge Problem Solving Training
              </Typography>}
            </Grid>
            {moduleSettings.moduleType !== "Training" && (
              <><Grid item xs={12}>
                <Typography variant="body1" component={"span"}>
                  {parse(moduleSettings.selectedModule.rules)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" component={"span"}>
                  {parse(moduleSettings.selectedModule.outcome)}
                </Typography>
              </Grid></>)}
            {moduleSettings.moduleType === "Training" && instructionStep === 1 && 
              <Grid item xs={12}>
                <Typography variant="body1" component={"span"}>
                  {parse(moduleSettings.selectedModule.rules)}
                </Typography>
              </Grid>}
            {moduleSettings.moduleType === "Training" && instructionStep === 2 &&
              <Grid item xs={12}>
                <Typography variant="body1" component={"span"}>
                  {parse(moduleSettings.selectedModule.outcome)}
                </Typography>
              </Grid>}
            {moduleSettings.moduleType === "Training" && instructionStep === 3 && moduleSettings.selectedModule.Medias[0]?.Media.source &&
              <>
                <Grid item xs={3} />
                <Grid item xs={6}>
                  <Typography variant="body1" component={"span"}>
                    {parse(moduleSettings.selectedModule.Medias[0]?.Media.source)}
                  </Typography>
                </Grid>
                <Grid item xs={3} />
              </>
            }
            {moduleSettings.moduleType === "Training" && <Grid item xs={12}>
              <Box display={"flex"} justifyContent="center">
                {instructionStep !== 1 && <Button
                  // variant="contained"
                  onClick={handlePrevStep}
                  sx={{ mr: 4 }}
                  startIcon={<ChevronLeft />}
                >
                  {instructionStep === 2 ? "Rules" : "Outcome"}
                </Button>}
                {instructionStep !== 3 && <Button
                  // variant="contained"
                  onClick={handleNextStep}
                  endIcon={<ChevronRightIcon />}
                >
                  {instructionStep === 1 ? "Outcome" : "Video" }
                </Button>}
              </Box>
            </Grid>}
            <Grid item xs={12}><Divider light="false" sx={{ mt: 1, mb: 1 }} /></Grid>
            <Grid item xs={12}>
              <Box display={"flex"} justifyContent="center">
                {location.from !== "/studenttraining" && location.from !== "/training-question" && <Button
                  variant="contained"
                  onClick={goToDashboard}
                  sx={{ mr: 4 }}
                >
                  Return to Dashboard
                </Button>}
                <Button
                  variant="contained"
                  onClick={
                    location.from === "/training-question"
                      ? () => history.push(location.from)
                      : startTest
                  }
                >
                  {location.from === "/training-question"
                    ? "return"
                    : `Start ${
                        (moduleSettings.moduleType === "Training" || moduleSettings.moduleType === "Interactive")
                          ? "Training"
                          : "Test"
                      }`}
                </Button>
              </Box>
            </Grid>
          </>
        )}
        {moduleSettings.moduleType === "Diagnostic" && (
          <>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Typography variant="h4">
                {moduleSettings.selectedModule.name}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Instructions for SolverEdge Behavioural Analysis Assessment
              </Typography>
              <br />
              <Typography variant="body1">
                Well done on completing the first part of the Problem Solving Behaviour & Ability test.
              </Typography>
              <Typography variant="body1">
                In the second part of this test, we will present the questions you have just answered in a different way. To help you improve your problem solving ability, we will provide you some hints & tips to help you answer the question correctly and collect useful diagnostic information. Please try your best to answer all the questions. 
              </Typography>
              <Typography variant="body1">
                <strong>You can press the SKIP QUESTION button at any time.</strong>
              </Typography>
              <Typography variant="body1">
                All you need to do is try your best!
              </Typography>
            </Grid>
            {/* <Grid item xs={12}>
              <Typography variant="body1">
                Please read the Instructions carefully before starting the test.
              </Typography>
            </Grid> */}
            <Grid item xs={12}>
              <Box display={"flex"} justifyContent="center">
                <Button
                  variant="contained"
                  onClick={goToDashboard}
                  sx={{ mr: 4 }}
                >
                  Return to Dashboard
                </Button>
                <Button variant="contained" onClick={startTest}>
                  Start Diagnostic Test
                </Button>
              </Box>
            </Grid>
          </>
        )}
      </Grid>
    );
  } else {
    return (
      <Grid container spacing={2}>
        { moduleSettings.moduleType === "Placement" && (
          <>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Typography variant="h4">
                {moduleSettings.selectedModule.name}
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              {moduleSettings.moduleType === "Placement" && (
                <Typography variant="subtitle1">
                  期間: {moduleSettings.selectedModule.duration} minutes
                </Typography>
              )}
              <Typography variant="subtitle1">
              問題總數: {moduleSettings.selectedModule.totalQuestions}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                SolverEdge 問題解決評估說明
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                在開始測試之前，請仔細閱讀說明。
              </Typography>
              <ol>
                <li>
                  <Typography variant="body1">
                    選擇答案後，按一下「下一步」按鈕繼續回答下一個問題。
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    題目順序不限，每次最多可跳過 4 題。點選「下一步」即可跳過該題。
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    您可以在分配的測試時間內隨時更改答案。
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    複習頁面上，標有每個試題編號的彩色方框指示了每個試題的狀態。請參考以下圖例：
                  </Typography>
                  <br />
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={2}
                      sx={{
                        ml: 1,
                        color: "black",
                        backgroundColor: "#9e9e9e",
                        textAlign: "center",
                      }}
                    >
                      灰色的
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="body1">
                        未回答/跳過問題
                      </Typography>
                    </Grid>
                    <Grid item xs={1} />
                    <Grid
                      item
                      xs={2}
                      sx={{
                        ml: 1,
                        color: "black",
                        backgroundColor: "#fdd835",
                        textAlign: "center",
                      }}
                    >
                      黃色的
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="body1">已回答的問題</Typography>
                    </Grid>
                  </Grid>
                  <br />
                </li>
                <li>
                  <Typography variant="body1">
                  若要跳過和/或標記要返回的問題，請按 <FlagIcon sx={{ color: "#C10015" }} />
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                  要查看您的答案，請按 <AppsIcon sx={{ color: "#C10015"}} />
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    除非您已檢查所有答案，否則請勿提交。提交試卷後，您將無法更改答案。
                  </Typography>
                </li>
              </ol>
            </Grid>
            <Grid item xs={12}>
              <Box display={"flex"} justifyContent="center">
                <Button
                  variant="contained"
                  onClick={goToDashboard}
                  sx={{ mr: 4 }}
                  disabled={loading}
                >
                  返回儀表板
                </Button>
                <Button
                  variant="contained"
                  onClick={startTest}
                  disabled={loading}
                >
                  開始測試
                </Button>
              </Box>
            </Grid>
          </>
        )}
        {(
          moduleSettings.moduleType === "Training" || moduleSettings.moduleType === "Interactive") && (
          <>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Typography variant="h4">
                {moduleSettings.selectedModule.name}
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              {moduleSettings.moduleType === "Placement" && (
                <Typography variant="subtitle1">
                  期間: {moduleSettings.selectedModule.duration} minutes
                </Typography>
              )}
              <Typography variant="subtitle1">
              問題總數: {moduleSettings.selectedModule.totalQuestions}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {moduleSettings.moduleType !== "Training" && 
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                SolverEdge 問題解決評估說明
              </Typography>}
            </Grid>
            {moduleSettings.moduleType !== "Training" && (
              <><Grid item xs={12}>
                <Typography variant="body1" component={"span"}>
                  {parse(moduleSettings.selectedModule.rules)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" component={"span"}>
                  {parse(moduleSettings.selectedModule.outcome)}
                </Typography>
              </Grid></>)}
            {moduleSettings.moduleType === "Training" && instructionStep === 1 && 
              <Grid item xs={12}>
                <Typography variant="body1" component={"span"}>
                  {parse(moduleSettings.selectedModule.rules)}
                </Typography>
              </Grid>}
            {moduleSettings.moduleType === "Training" && instructionStep === 2 &&
              <Grid item xs={12}>
                <Typography variant="body1" component={"span"}>
                  {parse(moduleSettings.selectedModule.outcome)}
                </Typography>
              </Grid>}
            {moduleSettings.moduleType === "Training" && instructionStep === 3 && moduleSettings.selectedModule.Medias[0]?.Media.source &&
              <>
                <Grid item xs={3} />
                <Grid item xs={6}>
                  <Typography variant="body1" component={"span"}>
                    {parse(moduleSettings.selectedModule.Medias[0]?.Media.source)}
                  </Typography>
                </Grid>
                <Grid item xs={3} />
              </>
            }
            {moduleSettings.moduleType === "Training" && <Grid item xs={12}>
              <Box display={"flex"} justifyContent="center">
                {instructionStep !== 1 && <Button
                  // variant="contained"
                  onClick={handlePrevStep}
                  sx={{ mr: 4 }}
                  startIcon={<ChevronLeft />}
                >
                  {instructionStep === 2 ? "規則" : "結果"}
                </Button>}
                {instructionStep !== 3 && <Button
                  // variant="contained"
                  onClick={handleNextStep}
                  endIcon={<ChevronRightIcon />}
                >
                  {instructionStep === 1 ? "結果" : "視頻" }
                </Button>}
              </Box>
            </Grid>}
            <Grid item xs={12}><Divider light="false" sx={{ mt: 1, mb: 1 }} /></Grid>
            <Grid item xs={12}>
              <Box display={"flex"} justifyContent="center">
                {location.from !== "/studenttraining" && location.from !== "/training-question" && <Button
                  variant="contained"
                  onClick={goToDashboard}
                  sx={{ mr: 4 }}
                >
                  返回儀表板
                </Button>}
                <Button
                  variant="contained"
                  onClick={
                    location.from === "/training-question"
                      ? () => history.push(location.from)
                      : startTest
                  }
                >
                  {location.from === "/training-question"
                    ? "返回"
                    : `開始 ${
                        (moduleSettings.moduleType === "Training" || moduleSettings.moduleType === "Interactive")
                          ? "訓練"
                          : "測試"
                      }`}
                </Button>
              </Box>
            </Grid>
          </>
        )}
        {moduleSettings.moduleType === "Diagnostic" && (
          <>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Typography variant="h4">
                {moduleSettings.selectedModule.name}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                SolverEdge 行為分析評估說明
              </Typography>
              <br />
              <Typography variant="body1">
                恭喜您完成了問題解決行為和能力測驗的第一部分。
              </Typography>
              <Typography variant="body1">
                在本次測驗的第二部分，我們將以不同的方式呈現您剛剛回答的題目。為了幫助您提高解題能力，我們將提供一些提示和技巧，幫助您正確作答題目並收集有用的診斷資訊。請盡力回答所有題目。
              </Typography>
              <Typography variant="body1">
                <strong>您可以隨時按下“跳過問題”按鈕。</strong>
              </Typography>
              <Typography variant="body1">
                您需要做的就是盡力而為！
              </Typography>
            </Grid>
            {/* <Grid item xs={12}>
              <Typography variant="body1">
                Please read the Instructions carefully before starting the test.
              </Typography>
            </Grid> */}
            <Grid item xs={12}>
              <Box display={"flex"} justifyContent="center">
                <Button
                  variant="contained"
                  onClick={goToDashboard}
                  sx={{ mr: 4 }}
                >
                  返回儀表板
                </Button>
                <Button variant="contained" onClick={startTest}>
                  開始診斷測試
                </Button>
              </Box>
            </Grid>
          </>
        )}
      </Grid>
    );
  }
  
};

export default Instructions;
